export default {
  GET_INQUIRIES: (state) => state.inquiries,
};
